import { UseFormRegister, FieldErrors } from 'react-hook-form';
import Input from '@/components/ui/Input';
import type { DonorFormData } from '@/lib/utils/validation';

interface DonorFormProps {
  register: UseFormRegister<DonorFormData>;
  errors: FieldErrors<DonorFormData>;
}

function DonorForm({ register, errors }: DonorFormProps) {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-100 mb-4 uppercase tracking-wider">
        Your Information
      </h3>

      <Input
        label="Email Address"
        type="email"
        placeholder="your@email.com"
        required
        error={errors.email?.message}
        {...register('email')}
        autoComplete="email"
        className="bg-dark-card border-dark-border text-gray-100 placeholder-gray-500"
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Input
          label="First Name"
          type="text"
          placeholder="John"
          error={errors.firstName?.message}
          {...register('firstName')}
          autoComplete="given-name"
          className="bg-dark-card border-dark-border text-gray-100 placeholder-gray-500"
        />

        <Input
          label="Last Name"
          type="text"
          placeholder="Doe"
          error={errors.lastName?.message}
          {...register('lastName')}
          autoComplete="family-name"
          className="bg-dark-card border-dark-border text-gray-100 placeholder-gray-500"
        />
      </div>

      <Input
        label="Phone Number"
        type="tel"
        placeholder="+1 (555) 123-4567"
        helperText="Optional - for donation receipt"
        error={errors.phone?.message}
        {...register('phone')}
        autoComplete="tel"
        className="bg-dark-card border-dark-border text-gray-100 placeholder-gray-500"
      />

      <div className="mt-4 p-4 bg-dark-lighter border border-dark-border rounded-lg">
        <p className="text-sm text-gray-400">
          <strong className="text-gray-300">Privacy Notice:</strong> Your information will only be used to process your
          donation and send you a receipt. We will never share your data with third parties.
        </p>
      </div>
    </div>
  );
}

export default DonorForm;
